import React from "react";

/**
 * A component that renders a select input with the given options
 *
 * @param {Object} props
 * @param {string} props.label - The label to be displayed in the button
 * @param {string} props.className - The CSS classes of the button
 * @param {boolean} props.disabled - Whether the button is disabled or not
 * @param {"button" | "submit" | "reset"} props.type - The HTML type of the button @default "button"
 * @returns {JSX.Element}
 */

export default function Button({
  className = "",
  onClick = () => {},
  label,
  disabled = false,
  type = "button",
}) {
  return (
    <button
      type={type}
      className={`${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
}
